// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

interface BookmarkItem {
  id: string | number;
  isBookmarked: boolean;
  [key: string]: unknown;
}

interface NavbarState {
  query: string;
  bookmarks: BookmarkItem[];
  suggestions: BookmarkItem[];
}

interface BookmarksResponse {
  data: BookmarkItem[];
  bookmarks: BookmarkItem[];
}

export const getBookmarks = createAsyncThunk('navbar/getBookmarks', async () => {
  const response = await axios.get<{ suggestions: BookmarkItem[]; bookmarks: BookmarkItem[] }>('/api/bookmarks/data')
  return {
    data: response.data.suggestions,
    bookmarks: response.data.bookmarks
  }
})

export const updateBookmarked = createAsyncThunk('navbar/updateBookmarked', async (id: string | number) => {
  await axios.post('/api/bookmarks/update', { id })
  return id
})

export const navbarSlice = createSlice({
  name: 'navbar',
  initialState: {
    query: '',
    bookmarks: [],
    suggestions: []
  } as NavbarState,
  reducers: {
    handleSearchQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getBookmarks.fulfilled, (state, action: PayloadAction<BookmarksResponse>) => {
        state.suggestions = action.payload.data
        state.bookmarks = action.payload.bookmarks
      })
      .addCase(updateBookmarked.fulfilled, (state, action: PayloadAction<string | number>) => {
        let objectToUpdate: BookmarkItem | undefined

        // ** find & update object
        state.suggestions.find(item => {
          if (item.id === action.payload) {
            item.isBookmarked = !item.isBookmarked
            objectToUpdate = item
          }
        })

        // ** Get index to add or remove bookmark from array
        const bookmarkIndex = state.bookmarks.findIndex(x => x.id === action.payload)

        if (bookmarkIndex === -1 && objectToUpdate) {
          state.bookmarks.push(objectToUpdate)
        } else {
          state.bookmarks.splice(bookmarkIndex, 1)
        }
      })
  }
})

export const { handleSearchQuery } = navbarSlice.actions

export default navbarSlice.reducer